import { useEffect, useRef, useState } from "react";

function DraggableText({
  id,
  text,
  placeholder,
  position,
  setPosition,
  onDelete,
  onSelect,
  onTextChange,
  isSelected,
  fontFamily,
  fontSize,
  fontColor,
  isBold,
  isTransparent,
}) {
  const [dragging, setDragging] = useState(false);
  const dragRef = useRef(null);
  const contentRef = useRef(null);

  useEffect(() => {
    if (contentRef.current && contentRef.current.innerText !== text) {
      contentRef.current.innerText = text || "";
    }
  }, [text]);

  const startDrag = (e) => {
    if (e.target.closest(".text-edit-area")) return;

    e.preventDefault();
    e.stopPropagation();

    onSelect(id);
    setDragging(true);

    dragRef.current = {
      startX: e.clientX,
      startY: e.clientY,
      originalX: position.x,
      originalY: position.y,
    };
  };

  useEffect(() => {
    const handleMove = (e) => {
      if (!dragging || !dragRef.current) return;

      const dx = e.clientX - dragRef.current.startX;
      const dy = e.clientY - dragRef.current.startY;

      setPosition(id, {
        x: Math.max(0, dragRef.current.originalX + dx),
        y: Math.max(0, dragRef.current.originalY + dy),
      });
    };

    const handleUp = () => {
      setDragging(false);
      dragRef.current = null;
    };

    document.addEventListener("mousemove", handleMove);
    document.addEventListener("mouseup", handleUp);

    return () => {
      document.removeEventListener("mousemove", handleMove);
      document.removeEventListener("mouseup", handleUp);
    };
  }, [dragging, id, setPosition]);

  const handleInput = (e) => {
    onTextChange(id, e.currentTarget.innerText);
  };

  return (
    <div
      onMouseDown={startDrag}
      onClick={(e) => {
        e.stopPropagation();
        onSelect(id);
      }}
      style={{
        position: "absolute",
        left: position.x,
        top: position.y,
        zIndex: isSelected ? 3000 : 2000,
        minWidth: "10px",
        minHeight: "10px",
        // padding: 0,
        paddingTop: "0px",
        paddingBottom: "0px",
        paddingLeft: "1.5px",
        paddingRight: "0px",
        margin: 0,
        border: isSelected ? "1px solid #2563eb" : "none",
        background: isTransparent ? "transparent" : "rgba(255,255,255,0.9)",
        cursor: "move",
        lineHeight: 1,
      }}
    >
      {isSelected && (
        <button
          onClick={(e) => {
            e.stopPropagation();
            onDelete(id);
          }}
          style={{
            position: "absolute",
            top: "-10px",
            right: "-10px",
            background: "red",
            color: "white",
            border: "none",
            borderRadius: "50%",
            width: "20px",
            height: "20px",
            cursor: "pointer",
            zIndex: 10,
            padding: 0,
          }}
        >
          ×
        </button>
      )}

      <div
        id={`text-content-${id}`}
        ref={contentRef}
        className="text-edit-area"
        contentEditable
        suppressContentEditableWarning
        spellCheck={false}
        data-placeholder={placeholder || "Type here..."}
        onInput={handleInput}
        onMouseDown={(e) => {
          e.stopPropagation();
          onSelect(id);
        }}
        style={{
          // padding: 0,
          paddingTop: "0px",
          paddingBottom: "0px",
          paddingLeft: "1.5px",
          paddingRight: "0px",
          margin: 0,
          minWidth: "10px",
          minHeight: `${fontSize}px`,
          outline: "none",
          fontFamily,
          fontSize: `${fontSize}px`,
          color: fontColor || "#000000",
          fontWeight: isBold ? "bold" : "normal",
          background: "transparent",
          lineHeight: 1,
          direction: "ltr",
          unicodeBidi: "plaintext",
          textAlign: "left",
          whiteSpace: "pre-wrap",
          cursor: "text",
        }}
      />
    </div>
  );
}

export default DraggableText;